<template>
    <el-row class="base-ref">
        <el-col :span="24">
            <el-input v-if="showModel == 0" v-model="inputValue" suffix-icon="el-input__icon el-icon-search" :readonly="readonly" :placeholder="placeholder" @focus="showDialogFocus()" :disabled="disabled" @click.native="handleClick"></el-input>
            <hht-ref-select v-if="showModel == 1"
                    :refModel="model"
                    :refCode="refCode"
                    :placeholder="placeholder"
                    :mulSelect="mulSelect"
                    :disabled="disabled"
                    :checkStrictly="checkStrictly"
                    :treeCondition="treeCondition"
                    :showNoExists="showNoExists"
                    @selectChange="selectChange"
                    v-model="currentValue"
            ></hht-ref-select>
        </el-col>

        <el-dialog class="ref-dialog" :title="dialogTitle" width="35%" :visible.sync="showDialog" :close-on-click-modal="false">
            <el-row>
                <ref-panel class="ref-panel"
                    :refModel="model"
                    ref="refPanelSearch"
                    @handleParentClick="showDialogFocus"
                    :refCode="refCode"
                    :treeFilterMethod="treeFilterMethod"
                    :areaNameSearch="areaNameSearch"
                    :mulSelect="mulSelect"
                    :checkStrictly="checkStrictly"
                    :withParent="withParent"
                    v-model="currentValue"
                ></ref-panel>
            </el-row>
            <el-row class="button-footer">
                <el-col :span="24">
                    <el-button @click="cancel">取 消</el-button>
                    <el-button type="primary" @click="confirm">确 定</el-button>
                </el-col>
            </el-row>
        </el-dialog>
    </el-row>
</template>
<script>
    import modelRouter from './refModelRouter.js';
    import RefPanel from './refPanel.vue'
    import mainUtil from '../../../pub/utils/mainUtil';
    export default {
        props:{
            refCode:String,
            treeFilterMethod:Function,  //用来对展示结果集进行过滤
            value:[String, Array],
            placeholder:String,
            disabled:Boolean,
            mulSelect:{
                type:Boolean,
                default:false
            },
            checkStrictly:{
                type:Boolean,
                default:false
            },
            withParent:{
                type:Boolean,
                default:false
            },
            showModel:{      //0  参照展现，   1  下拉展现
                type:Number,
                default:0
            },
            showNoExists:{     //是否显示不存在的下拉值   只在下拉状态显示值
                type:Boolean,
                default:false
            },
            readonly:{ //是否只读
                type:Boolean,
                default:false
            },
            focusModel:{
                type:Boolean,
                default:true
            },
            treeCondition:Object,  //树条件，用于传递给后端接口
            listCondition:Object,  //列表查询条件，用于传递给后端接口
            areaNameSearch:String
        },
        data(){
            var _model = modelRouter[this.refCode];
            return {
                model:_model,
                currentValue:null,
                inputValue:'',
                hiddenValue:null,
                refKey:'',
                showDialog:false,
                dialogTitle:_model.refConfig.refName,
                dialogSize:_model.refConfig.dialogSize?_model.refConfig.dialogSize:'tiny',
            }
        },
        components: {
            RefPanel
        },
        watch:{
            value:{
                immediate: true,
                handler:function(v, oldv){
                    // if (this.refCode=='dish-class')
                    
                    if(v){
                        if(this.showModel == 1){
                            this.currentValue = v;
                        }else{
                            if(v != this.hiddenValue) this.getOne(v);
                        }
                    }else{
                        this.inputValue = null;
                        this.currentValue = null;
                    }
                }
            },
            currentValue:function(v){

            }
        },
        created() {

        },
        methods:{
            getOne:function(v){
                var _self = this;
                if(this.mulSelect){
                    this.model.getListByPks(v,function(data){

                        _self.currentValue= data;
                        _self.setValue(true);
                    });
                }else{
                    this.model.getOne(v,function(data){
                        _self.inputValue = data;
                    });
                }
            },
            handleClick:function(){
                this.showDialog = true;
            },
            showDialogFocus:function() {
              this.showDialog = true;
              if ( this.areaNameSearch ) {
                //当选择地区的时候调用孙子组件过滤方法
                this.$nextTick(() => {
                  this.$refs.refPanelSearch.handleSearch();
                })
              }
              
            },
            confirm:function(){

                this.setValue();
            },
            setValue:function(noReturn){
                var selData = this.currentValue;
                var refFields = this.model.getRefFields();
                if(this.mulSelect){ //多选
                    var id =[], name = [], shortValue=[];
                    if(this.model.filterResult){
                        if(!selData || !selData.length){
                            var msg = this.model.getFilterResultMsg() || "请选择数据";
                            return this.model.showMessage('提示',msg,'info');
                        }
                        selData = selData.filter(d => this.model.filterResult(d));
                    }
                    selData.forEach((d) => {
                        id.push(d[refFields.id]);
                        name.push(d[refFields.name]);
                        shortValue.push({
                            id:d[refFields.id],
                            name:d[refFields.name]
                        })
                    });
                }else{
                    if(!selData || (this.model.filterResult && !this.model.filterResult(selData))){
                        var msg = this.model.getFilterResultMsg() || "请选择数据";
                        return this.model.showMessage('提示',msg,'info');
                    }
                    var name = selData[refFields.name];
                    var id = selData[refFields.id];
                    var shortValue={
                        id:id,
                        name:name
                    }
                }
                this.showDialog = false;
                this.inputValue = mainUtil.isArray(name)?name.join(','):name;
                this.refKey = id;
                this.hiddenValue = this.refKey;
                if(noReturn) return;
                this.$emit('input', this.refKey);
                this.$emit('afterRef', selData, shortValue, refFields, this.refCode);
            },
            cancel:function(){
                this.showDialog = false;
                this.$emit('cancel');
            },
            selectChange:function(selData){
                //var selData = this.currentValue;

                var refFields = this.model.getRefFields();
                var shortValue = null;
                this.$emit('input', this.currentValue);
                this.$emit('afterRef', selData, shortValue, refFields, this.refCode);
            }
        }
    }
</script>

<style>
    .base-ref .el-dialog__header{
        line-height: 36px;
    }

    .base-ref .ref-dialog .search-area{
        padding-bottom: 10px;
    }
    .base-ref .el-icon-search{
        cursor: pointer;
    }
    .base-ref .el-dialog__body{
        padding-bottom: 0px;
        padding-top:0px;
    }
    .base-ref .el-dialog__footer{
        padding-top:0px;
    }
    .base-ref .ref-panel{
        height: 470px;
    }

    .base-ref .button-footer{
        height: 50px;
        text-align: center;
        margin-top: 10px;
        margin-bottom: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/pub/components/baseRef/refInput.vue